export const compartirLink = async (link) =>{

    if (navigator.share) {
        try {
            await navigator.share({
                title: 'Título de tu contenido',
                text: 'Un texto descriptivo para compartir',
                url: link,
            });
            console.log('Contenido compartido con éxito');
        } catch (error) {
            console.error('Error al compartir:', error);
        }
    } else {
        alert('Tu navegador no soporta la API de Compartir Nativa.');
    }



}